module.exports = __webpack_public_path__ + "3a3706e99a9aee2270f5e0f32c79c788.png";


//////////////////
// WEBPACK FOOTER
// ./assets/src/js/images/header_back.png
// module id = 1103
// module chunks = 0